module.exports = __webpack_public_path__ + "static/media/crocodile(1).84c304a8.PNG";